import React from 'react';
import { CheckBalanceTypes } from '../../CheckBalanceTypes';
import { checkBalanceLabels } from '../../constants/accountPanelConfigs';
import { weakKey } from '../../../../utilities/weakKey';

export const UnitDetails = ({
  data,
  relational_data,
}: CheckBalanceTypes.TUnitDetailsProps) => {
  const { unitSectionLabel, currency_sign_dollar } = checkBalanceLabels;
  const UnitDetails = new Map(
    relational_data &&
      relational_data.unit_type &&
      relational_data.unit_type.map((unit: { id: string }) => [unit.id, unit])
  );

  data &&
    data.map((unit: { unit_type: any }) => {
      const units: any = UnitDetails.get(unit.unit_type.id);

      if (units) {
        unit.unit_type = units;
      }
    });

  const UnitDetailsTable = () => {
    return (
      <div className="tableContainer">
        <table className="unitDetailsTable">
          <thead>
            <tr>
              <th className="tableColumn smallColumn">
                <p className="subtitle1">Unit Number</p>
              </th>
              <th className="tableColumn smallColumn">
                <p className="subtitle1">Unit Size</p>
              </th>
              <th className="tableColumn smallColumn">
                <p className="subtitle1">Unit Rent</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map(({ label, unit_type, current_rate, period }: any) => (
                <tr key={weakKey({ label })}>
                  <td className="subtitle2">{label}</td>
                  <td className="subtitle2">{unit_type.value.description}</td>
                  <td className="subtitle2">
                    {currency_sign_dollar} {current_rate}/{period}{' '}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="transactionHistoryParentContainer">
      <div className="transactionHistoryContainer">
        <div className="transactionHistoryLabel">
          <h5>{unitSectionLabel}</h5>
        </div>

        {data?.length > 0 ? (
          <UnitDetailsTable />
        ) : (
          <p className="subtitle1">No Unit Details Available</p>
        )}
      </div>
    </div>
  );
};
